/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconCandleFire: {
  name: 'candle_fire';
  data: string;
} = {
  name: 'candle_fire',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M218.148 24.589c28.958 222.269-112.685 336.106-83.301 445.765 4.384 16.362 12.201 31.303 22.58 44.658-3.07-8.535-4.831-17.528-5.031-26.89-1.259-58.963 60.355-110.216 104.4-192.734 13.78 37.367 28.449 82.164 20.028 139.003 75.227-21.841 132.397-79.526 144.876-140.653 57.843 103.526 49.568 225.493-59.979 288.505a112.67 112.67 0 0 1-7.784 4.073c29.821-4.293 57.519-15.249 79.15-33.774h.001c177.464-151.981 30.918-428.733-214.94-527.953z"/></svg>`,
};
